module.exports = __webpack_public_path__ + "static/media/hero-book-render.44115cc1.png";